import React, { useEffect, useState } from 'react';
import useDashboardContext from 'contexts/dashboard.context';
import FormStepper from 'components/base/form-stepper';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
import { useNavigate } from 'react-router-dom';
import { AddInternalProcurementType } from 'models/procurement.model';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import AddKitchenProcurementForm from './add-procurement-form';
import AddKitchenProcurementPreview from './add-procurement-preview';
import useRoleContext from 'contexts/role.context';
import { InventoryModule, RolePermission } from 'models/permission.model';

export const vendorOptions = [
  { id: '1', name: 'Femite food ltd', price: 'N 1,700/gram' },
  { id: '2', name: 'Femite food ltd', price: 'N 1,700/gram' },
  { id: '3', name: 'Femite food ltd', price: 'N 1,700/gram' },
  { id: '4', name: 'Femite food ltd', price: 'N 1,700/gram' }
];

const initialProcurement = {
  ingredient_id: '',
  ingredient_name: '',
  unit_type: '',
  quantity: '',
  ingredient: null
};

const KitchenNewProcurement = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const { setIsBackLink, setBackLinkTitle } = useDashboardContext();
  const [formData, setFormData] = useState<AddInternalProcurementType[]>([initialProcurement]);
  const [isCreatingProcurementRequest, setIsCreatingProcurementRequest] = useState(false);
  const router = useNavigate();
  const { activeStore } = useDashboardContext();
  const { can } = useRoleContext();
  const canWriteProcurement = can(InventoryModule.KitchenRequisition, RolePermission.Write);

  useEffect(() => {
    setIsBackLink(true);
    setBackLinkTitle('Return to procurement');
    return () => {
      setIsBackLink(false);
      setBackLinkTitle('');
    };
  }, []);

  const setValue = (
    index: number,
    field: keyof AddInternalProcurementType,
    value: AddInternalProcurementType[keyof AddInternalProcurementType]
  ) => {
    setFormData((prev) =>
      prev.map((data, i) => (i === index ? { ...data, [field]: value } : data))
    );
  };

  const addForm = () => setFormData([...formData, { ...initialProcurement }]);

  const removeItem = (index: number) => setFormData(formData.filter((data, i) => i !== index));

  function isFormFilled(data: AddInternalProcurementType[]): boolean {
    return data.every((item) => {
      const hasIngredient = !!(item.ingredient?.id || item.ingredient_id);
      const hasQuantity = !!item.quantity;
      return hasIngredient && hasQuantity;
    });
  }

  const data = {
    items: formData.map((request) => {
      const ingredientId = request.ingredient?.id || request.ingredient_id;
      return {
        ingredient_id: ingredientId,
        quantity: Number(request.quantity)
      };
    }),
    store_id: activeStore?.id
  };

  const createProcurementRequest = async () => {
    if (!canWriteProcurement) return;
    if (!activeStore?.id) return;
    try {
      setIsCreatingProcurementRequest(true);
      const response = await apiService.post(`kitchen-store/requests`, {
        data,
        version: 'v2'
      });
      if (response) {
        router(MAIN_STORE_ROUTE_KEYS.KITCHEN_PROCUREMENT);
        toast(<ToastMessage message='Kitchen request created successfully' type='success' />);
      }
    } catch (err: any) {
      toast(
        <ToastMessage
          message={err.response?.data?.message || 'Error creating procurement request'}
          type='error'
        />
      );
    } finally {
      setIsCreatingProcurementRequest(false);
    }
  };

  const handleEdit = () => setStep(1);
  return (
    <div className='ml-2 md:ml-8'>
      <h4 className='text-[24px] font-semibold text-[#2E3031]'>Create Procurement Request</h4>
      <p className='text-[#6F7376] text-sm mb-8'>
        Inventory running low on certain items? prepare your list
      </p>
      <div className=' w-full max-w-[678px]'>
        <FormStepper
          disabled={step === 1 ? !isFormFilled(formData) : false}
          hidePrimaryAction={!canWriteProcurement}
          step={step}
          title={step === 1 ? 'Make your selections' : 'Review selections'}
          subtitle={step === 2 ? 'Ensure you have all items needed selected' : ''}
          setStep={setStep}
          handleConfirmClick={() => {
            createProcurementRequest();
          }}
          loading={isCreatingProcurementRequest}
          handleCancelClick={() => {
            navigate(-1);
          }}>
          {step === 1 ? (
            <div>
              {formData.map((data, index) => (
                <AddKitchenProcurementForm
                  key={index}
                  data={data}
                  index={index}
                  setValue={setValue}
                  removeItem={removeItem}
                  canWrite={canWriteProcurement}
                />
              ))}
              {canWriteProcurement && (
                <button onClick={addForm} className='text-[#0080E5] mt-2 font-medium text-sm'>
                  + Add Item
                </button>
              )}
            </div>
          ) : (
            <div>
              <AddKitchenProcurementPreview formData={formData} handleEdit={handleEdit} />
            </div>
          )}
        </FormStepper>
      </div>
    </div>
  );
};

export default KitchenNewProcurement;
